{
  "name": "worldcup2026-app",
  "version": "1.2.3",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "build-prod": "ng build --configuration production",
    "watch": "ng build --watch --configuration development",
    "deploy": "npx gulp deploy",
    "favicons": "npx gulp favicons"
  },
  "private": true,
  "dependencies": {
    "@amplitude/analytics-browser": "^1.5.4",
    "@angular/animations": "^21.2.8",
    "@angular/cdk": "^21.2.6",
    "@angular/common": "^21.2.8",
    "@angular/compiler": "^21.2.8",
    "@angular/core": "^21.2.8",
    "@angular/forms": "^21.2.8",
    "@angular/material": "^21.2.6",
    "@angular/platform-browser": "^21.2.8",
    "@angular/platform-browser-dynamic": "^21.2.8",
    "@angular/router": "^21.2.8",
    "@angular/service-worker": "^21.2.8",
    "@tinymce/tinymce-angular": "^9.1.1",
    "canvas-confetti": "^1.9.4",
    "chart.js": "^4.5.1",
    "crypto-es": "^3.1.3",
    "ng-block-ui": "^4.0.1",
    "rxjs": "~7.5.0",
    "tinymce": "^8.4.0",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular/build": "^21.2.7",
    "@angular/cli": "~21.2.7",
    "@angular/compiler-cli": "^21.2.8",
    "@types/canvas-confetti": "^1.9.0",
    "@types/node": "^20.19.39",
    "child_process": "^1.0.2",
    "favicons": "^7.2.0",
    "fs-extra": "^10.1.0",
    "gulp": "^4.0.2",
    "gulp-zip": "^5.1.0",
    "typescript": "~5.9.3"
  }
}
